import React from 'react';
import { Grid, Typography } from '@mui/material';
import { UserTextField } from '../UserTextField';
import { RoleField } from './RoleField';

/** The user drawers' Details section: name, email (how they sign in), phone and role. */
export const DetailsFields = () => (
	<>
		<Grid size={12}>
			<Typography variant='form_label'>Details</Typography>
		</Grid>
		<UserTextField name='name' required />
		<UserTextField
			name='email'
			helperText='The user signs in with this email'
			sm={6}
			required
		/>
		<UserTextField name='phoneNumber' sm={6} />
		<RoleField />
	</>
);
